import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSliderStyle0 = gravityIconIndividualCss;

const GravityIconSlider = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '2b709f4e93b8787e4c114a8176e818a810311750', color: this.color, size: this.size }, h("svg", { key: '3ddc00d853acfdf67e19c5a3912536ca2388a6df', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '230aec14c4d103943f7c0697322f879ca3edd1cc', d: "M15.5 6.25h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3V9.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v1.75Zm-3 7a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-6ZM8.5 11H8a.5.5 0 0 0-.5.5v1.75h-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4v1.75a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5Zm-5-4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-7Z", fill: "currentColor" }))));
    }
};
GravityIconSlider.style = GravityIconSliderStyle0;

export { GravityIconSlider as gravity_icon_slider };

//# sourceMappingURL=gravity-icon-slider.entry.js.map